// Suggested page whose Search Console queries are shown when a property is chosen.
// A domain property has no page URL, so it defaults to https://www.<domain>/.
// An http(s) property is used as selected, including its path, slash and host case.
export function homepageUrlFromProperty(propertyUrl: string): string {
  const raw = propertyUrl.trim();
  const domainPrefix = "sc-domain:";
  if (raw.toLowerCase().startsWith(domainPrefix)) {
    const domain = raw.slice(domainPrefix.length).replace(/^\/+|\/+$/g, "");
    const host = domain.toLowerCase().startsWith("www.")
      ? domain
      : `www.${domain}`;
    return `https://${host}/`;
  }
  return raw;
}

export function isHttpPageUrl(value: string): boolean {
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}
